import { forwardRef } from 'react';
import styles from './label.module.css';
import clsx from 'clsx';

export type LabelProps = React.ComponentPropsWithoutRef<'label'>;

// props.hidden visually hides label element, but still makes it available to screen readers
const LabelComp = (
  { className, ...rest }: LabelProps,
  ref: React.ForwardedRef<HTMLLabelElement>
) => {
  return (
    <label className={clsx(styles.label, className)} ref={ref} {...rest} />
  );
};

export const Label = forwardRef<HTMLLabelElement, LabelProps>(LabelComp);

Label.displayName = 'Label';
